import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { COLORS } from "@ts/constants";
import { IDriverwiseReviewTrendWidgetData } from "@ts/common-types";
import NoData from "highcharts/modules/no-data-to-display";
import WidgetCard from "./WidgetCard";

NoData(Highcharts);

interface IDriverwiseReviewTrend {
    title?: string;
    type?: string;
    widgetData: IDriverwiseReviewTrendWidgetData[];
}

const DriverwiseReviewTrend: React.FC<IDriverwiseReviewTrend> = ({
    title,
    type,
    widgetData,
}) => {
    const chartRefs = React.useRef([]);
    const getChartOptions = (
        series: Array<{
            name?: string;
            data?: Array<[string, number]>;
            color?: string;
        }>
    ) => ({
        chart: {
            type: "spline",
            responsive: true,
            height: 300,
            scales: {
                x: {
                    title: {
                        display: true,
                        text: ''
                    }
                },
                y: {
                    title: {
                        display: true,
                        text: 'Rating'
                    },
                    min: 3.5,
                    max: 5,
                    ticks: {
                        stepSize: 0.5
                    }
                }
            },
            plugins: {
                legend: {
                    display: true,
                    position: 'top'
                },
                tooltip: {
                    mode: 'index',
                    intersect: false
                }
            }
        },
        colors: COLORS,
        title: {
            text: "",
        },
        xAxis: {
            type: "datetime",
            title: {
                text: "",
            },
            labels: {
                formatter: function (this: any) {
                    const date = new Date(this.value);
                    const day = String(date.getUTCDate()).padStart(2, "0");
                    const month = String(date.getUTCMonth() + 1).padStart(
                        2,
                        "0"
                    );
                    const year = date.getUTCFullYear();
                    return `${day}-${month}-${year}`;
                },
            },
        },
        yAxis: {
            title: {
                text: "Rating",
            },
            labels: {
                style: {
                    color: "#000",
                    fontWeight: "bold",
                },
            },
            min: 0,
            max: 5,
        },
        legend: {
            layout: "horizontal",
            align: "center",
            floating: false,
            verticalAlign: "top",
        },
        tooltip: {
            shared: true,
            crosshairs: true,
        },
        credits: {
            enabled: false,
        },
        series,
        lang: {
            noData: "No data to display",
        },
        noData: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                color: "#303030",
            },
        },
        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 500,
                    },
                    chartOptions: {
                        legend: {
                            align: "center",
                            verticalAlign: "bottom",
                            layout: "horizontal",
                        },
                    },
                },
            ],
        },
    });

    return (
        <WidgetCard
            className={
                type === "sub-module"
                    ? "bg-transparent border-0 shadow-none"
                    : ""
            }
        >
            {type !== "sub-module" ? (
                <h5 className="mb-3">
                    {title || "Driverwise Review Trend"}
                </h5>
            ) : null}
            <HighchartsReact
                highcharts={Highcharts}
                options={getChartOptions(widgetData || [])}
                ref={(el) => (chartRefs.current[1] = el)}
            />
        </WidgetCard>
    );
};

export default DriverwiseReviewTrend;